var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-container"},[_c('h1',[_vm._v("【错误如图所示】")]),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/ksxg/banner01.png")}})]),_c('div',{staticClass:"text"},[_c('span',[_vm._v(" 针对湖北地区的新老客户，驰声从即日起提供语音评测资源的支持。欢迎联系我们，驰声语音评测技术专家团队随时为您守候。针对湖北地区的新老客户，驰声从即日起提供语音评测资源的支持。欢迎联系我们，驰声语音评测技术专家团队随时为您守候。")])])])
}]

export { render, staticRenderFns }